import { DetailsRow } from "~/components/details/DetailsSection"
import { IssueSetting } from "./IssueSetting"
import { IssueDueDatePicker } from "./IssueDueDatePicker"
import type { RouterOutputs } from "~/trpc/react"

export function IssuePropertiesFields({
	value,
	onChange,
	disabled,
	activeTeamId,
	labeled = false,
	layout = "stack",
	requireTeam = true
}: {
	value: Pick<
		NonNullable<RouterOutputs["issues"]["get"]>,
		"status" | "priority" | "difficulty" | "dueDate"
	>
	onChange: (
		change: Partial<
			Pick<
				NonNullable<RouterOutputs["issues"]["get"]>,
				"status" | "priority" | "difficulty" | "dueDate"
			>
		>
	) => void
	disabled?: boolean
	activeTeamId?: string | null
	labeled?: boolean
	layout?: "stack" | "pills"
	requireTeam?: boolean
}) {
	return (
		<div
			className={
				layout === "pills"
					? "flex flex-wrap items-center gap-2"
					: "flex flex-col gap-3"
			}
		>
			{(["status", "priority", "difficulty"] as const).map((field) => {
				const control = (
					<IssueSetting
						shape={layout === "pills" ? "pill" : "default"}
						ariaLabel={`Issue ${field}`}
						requireTeam={requireTeam}
						value={value[field]}
						options={field}
						onChange={(next) => onChange({ [field]: next })}
						disabled={disabled}
						activeTeamId={activeTeamId}
						showArrow={labeled}
						showBorder={labeled || layout === "pills"}
					/>
				)
				return labeled ? (
					<DetailsRow
						key={field}
						label={field[0]!.toUpperCase() + field.slice(1)}
					>
						{control}
					</DetailsRow>
				) : (
					<div key={field}>{control}</div>
				)
			})}
			{labeled ? (
				<DetailsRow label="Due date">
					<IssueDueDatePicker
						value={value.dueDate}
						onChange={(dueDate) => onChange({ dueDate })}
						disabled={disabled}
						showBorder
					/>
				</DetailsRow>
			) : (
				<div>
					<IssueDueDatePicker
						shape={layout === "pills" ? "pill" : "default"}
						showBorder={layout === "pills"}
						value={value.dueDate}
						onChange={(dueDate) => onChange({ dueDate })}
						disabled={disabled}
					/>
				</div>
			)}
		</div>
	)
}
